import { put } from "redux-saga/effects";
import { DynamicReportAction } from "../../action";
import { Client } from "../../../../utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";

export function* downloadDynamicReportSaga(data) {
  const config = {
    method: "POST",
    url: "query/reports/dynamic_report",
    headers: {
      // Accept: "application/json",
      "Content-Type": "application/json",
      ...data.payload.headers,
    },
    data: data.payload.body,
    fetchPolicy: "no-cache",
  };
  try {
    const response = yield Client.request(config);

    if (response.status === 200) {
      downloadReport(
        response,
        data.payload.reportName,
        data.payload.body.download_type,
        data.payload.customFieldsLabels
      );
      yield put(DynamicReportAction.downloadDynamicReportSuccess());
    } else {
      yield put(
        DynamicReportAction.downloadDynamicReportFailed(SOMETHING_WENT_WRONG)
      );
    }
  } catch (err) {
    console.log(err);
    yield put(
      DynamicReportAction.downloadDynamicReportFailed(SOMETHING_WENT_WRONG)
    );
  }
}
const customHeaderMapping = {
  employee_id: "Employee ID",
  first_name: "First Name",
  last_name: "Last Name",
  email: "Email",
  secondary_email: "Secondary Email",
  gender: "Gender",
  designation: "Designation",
  phone_number: "Phone Number",
  date_of_joining: "Date of Joining",
  date_of_birth: "Date of Birth",
  created_date: "Created Date",
  group_name: "Team Name",
  manager: "Manager",
  punch_duration: "Total Working Time",
  shift_name: "Shift Name",
  shift_start_dt: "Shift Start Date",
  shift_end_dt: "Shift End Date",
  online_duration: "Total Online Time",
  active_duration: "Total Active Time",
  active_percent: "Activity %",
  break_duration: "Total Break Time",
  productive_duration: "Total Productive Time",
  productive_percent: "Productivity %",
  avg_break_duration: "Average Break Time",
  punch_in: "Punch In time",
  punch_out: "Punch Out time",
  idle_duration: "Total Idle Time",
  aitime: "Average Idle Time",
  avg_prod_duration: "Average Productive Time",
  unproductive_duration: "Total Unproductive Time",
  avg_unprod_duration: "Average Unproductive Time",
  neutral_duration: "Total neutral time",
  avg_neutral_duration: "Average neutral time",
  top_application_used: "Top Application Used",
  top_application_duration: "Top Application Duration",
  top_url_used: "Top URL Used",
  top_url_duration: "Top URL Duration",
};

const formatHeader = (header, customFieldsLabels) => {
  if (customHeaderMapping[header]) {
    return customHeaderMapping[header];
  }
  if (customFieldsLabels && customFieldsLabels[header]) {
    return customFieldsLabels[header];
  }

  return header
    .replace(/_/g, " ")
    .replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
};
const downloadReport = (response, fileName, format, customFieldsLabels) => {
  try {
    let data =
      format === "json" ? JSON.stringify(response.data) : response.data;

    const firstLineBreakIndex = data.indexOf("\n");
    const originalHeader = data.slice(0, firstLineBreakIndex);
    const rows = data.slice(firstLineBreakIndex + 1);

    // 🔄 Format each header field dynamically
    const updatedHeader = originalHeader
      .split(",")
      .map((col) => formatHeader(col, customFieldsLabels))
      .join(",");

    const finalData = `${updatedHeader}\n${rows}`;

    const blob = new Blob([finalData], {
      type: "application/octet-stream",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.log(err);
    DynamicReportAction.downloadDynamicReportFailed(SOMETHING_WENT_WRONG);
  }
};
